import { useSetAtom } from 'jotai';

import protectionModalCartItemIdAtom from './protectionModalCartItemIdAtom';

const useSetProtectionModalCartItemId = () => {
  const setProtectionModalCartItemId = useSetAtom(
    protectionModalCartItemIdAtom
  );

  return setProtectionModalCartItemId;
};

export default useSetProtectionModalCartItemId;
